import {
	AppBar,
	Fab,
	Toolbar,
	Typography,
	withStyles
} from "@material-ui/core";

import {
	Add as AddIcon,
	Image as ImageIcon,
	Menu as MenuIcon,
	Search as SearchIcon
} from "@material-ui/icons";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./styles";
import Title from "./Title";
import Filters from "./Filters";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { openMedia, openSearch, openSidebar } from "../../store/helpers";
import { version } from "../../config";
import RightMedia from "./RightMedia";
import PoiRightMenu from "../../views/district/PoiRightMenu";

class DesktopHeader extends React.Component {
	renderMobile = () => {
		const {
			classes,
			search,
			sidebar,
			media,
			handleOpenSearch,
			handleOpenSidebar,
			handleOpenMedia
		} = this.props;
		return (
			<div className={classNames(classes.advancedSearch)}>
				<Fab
					className={classNames(classes.btnOpenSidebar)}
					color="primary"
					onClick={handleOpenSidebar}
					style={{
						display: "inline-flex",
						width: 40,
						height: 40,
						marginRight: 20
					}}
				>
					<MenuIcon />
				</Fab>
				{!version.office ? (
					<Fab
						className={classNames(
							classes.btnOpenSidebar,
							search.opened && !sidebar.opened
								? classes.advancedSearchOpened
								: ""
						)}
						color="primary"
						onClick={handleOpenSearch}
						style={{
							display: "inline-flex",
							width: 40,
							height: 40
						}}
					>
						<SearchIcon />
					</Fab>
				) : (
					<Fab
						className={classNames(classes.btnOpenSidebar)}
						color="primary"
						onClick={handleOpenMedia}
						style={{
							display: "inline-flex",
							width: 40,
							height: 40
						}}
					>
						<ImageIcon />
					</Fab>
				)}
			</div>
		);
	};

	renderDesktop = () => {
		const { classes, handleOpenSearch, search } = this.props;
		return (
			<div className={classNames(classes.advancedSearch)}>
				<Typography
					style={{
						display: "inline-flex",
						lineHeight: 2.5,
						marginRight: 20,
						color: "#000000"
					}}
					variant="h4"
				>
					{"RECHERCHE AVANCÉE"}
				</Typography>
				<Fab
					className={classNames(
						classes.btnOpenSidebar,
						classes.btn,
						search.opened ? classes.advancedSearchOpened : ""
					)}
					color="primary"
					onClick={handleOpenSearch}
					style={{
						display: "inline-flex",
						minHeight: 1
					}}
				>
					<AddIcon />
				</Fab>
			</div>
		);
	};

	render() {
		const { classes, isMobile } = this.props;
		return (
			<>
				<AppBar className={classNames(classes.appBar)} position="fixed">
					<Toolbar className={classes.toolbar}>
						<Title classes={classes} />
						{isMobile || version.office ? null : <Filters classes={classes} />}
						{version.office && !isMobile && <RightMedia classes={classes} />}
						{isMobile
							? this.renderMobile()
							: version.office
							? null
							: this.renderDesktop()}
					</Toolbar>
					{version.office && <div className={classes.underHeaderLine} />}
				</AppBar>
			</>
		);
	}
}

const mapStateToProps = state => ({
	...state.helpers
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleOpenSearch: openSearch,
			handleOpenSidebar: openSidebar,
			handleOpenMedia: openMedia
		},
		dispatch
	);

DesktopHeader.propTypes = {
	classes: PropTypes.object.isRequired,
	handleOpenSearch: PropTypes.func.isRequired,
	handleOpenSidebar: PropTypes.func.isRequired,
	handleOpenMedia: PropTypes.func.isRequired,
	setIsMediaShow: PropTypes.func,
	isMobile: PropTypes.bool.isRequired,
	search: PropTypes.object.isRequired,
	sidebar: PropTypes.object.isRequired
};
export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(DesktopHeader)
);
